import React from "react";
import InfoPage from "../InfoPage";
import Settings from "../../components/Settings";

const TravelerSettings = () => {
    return (
        <InfoPage 
            title="Settings"
            below={
                <Settings userType="traveler" />
            }
            tallOverride={false}
            customMinHeight={800}
            disableStamps
        />
    );
};

export default TravelerSettings;




